import React from "react";
import { Github, Download, BookOpen, Home } from "lucide-react";

interface HeaderProps {
  glassStyle: string;
}

const Header: React.FC<HeaderProps> = ({ glassStyle }) => {
  const handleImageError = (
    e: React.SyntheticEvent<HTMLImageElement, Event>
  ) => {
    console.error("Failed to load Tavily logo");
    console.log("Image path:", e.currentTarget.src);
    e.currentTarget.style.display = "none";
  };

  return (
    <div className="relative mb-16">
      <div className="text-center pt-4">
        <h1 className="text-[48px] font-medium text-[#1a202c] font-['DM_Sans'] tracking-[-1px] leading-[52px] text-center mx-auto antialiased">
          Company Research Agent
        </h1>
        <p className="text-gray-600 text-lg font-['DM_Sans'] mt-4">
          Conduct in-depth company diligence powered by Tavily
        </p>
      </div>
      <div className="absolute top-0 right-0 flex items-center space-x-2">
      <a
          href="https://app.tavily.com/home"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Tavily Home"
        >
          <div className="p-2 bg-[#468BFF] rounded-lg hover:bg-[#8FBCFA] transition-colors cursor-pointer shadow-md">
            <Home className="text-white h-6 w-6" />
          </div>
        </a>
        <a
          href="https://github.com/pogjester/company-research-agent"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Tavily GitHub"
        >
          <div className="p-2 bg-[#FE363B] rounded-lg hover:bg-[#FF9A9D] transition-colors cursor-pointer shadow-md">
            <Github className="text-white h-6 w-6" />
          </div>
        </a>
        <a
          href="https://docs.tavily.com/examples/use-cases/company-research"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Tavily Website"
        >
          <div className="p-2 bg-[#FDBB11] rounded-lg hover:bg-[#F6D785] transition-colors cursor-pointer shadow-md">
            <BookOpen className="text-white h-6 w-6" />
          </div>
        </a>
      </div>
    </div>
  );
};

export default Header;
